export const whatsappMetaConfigQueryKeys = {
  configs: ["whatsapp-meta-configs"] as const,
  phoneNumbers: (configId: string) =>
    ["whatsapp-meta-configs", configId, "phone-numbers"] as const,
  templates: (configId: string) =>
    ["whatsapp-meta-configs", configId, "message-templates"] as const,
} as const;
